import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// Actions
import { resetError, resetSuccess, resetWarning } from "../../actions";

// MUI Components
import Snackbar from "@material-ui/core/Snackbar";
import ErrorIcon from "@material-ui/icons/Error";
import IconButton from "@material-ui/core/IconButton";
import WarningIcon from "@material-ui/icons/Warning";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/CheckCircle";
import Slide from "@material-ui/core/Slide";
import Typography from "@material-ui/core/Typography";

// Other Files
import { colors } from "../../constants/colors";

const SnackbarInfo = (props) => {
  const [snackbar, setValues] = React.useState({
    bckgrndColor: null,
    message: null,
    icon: null,
    textColor: null,
  });

  const useStyles = makeStyles({
    root: {
      "& div": {
        backgroundColor: snackbar.bckgrndColor, // Color set when snackbar opens
        width: "auto",
        maxWidth: "90vw",
      },
    },
    message: {
      alignItems: "center",
      color: snackbar.textColor,
      overflowWrap: "break-word",
      display: "inline-block",
      maxWidth: "70vw",
    },
    messageContainer: {
      display: "flex",
      alignItems: "center",
      "& svg": {
        marginRight: "10px",
        color: snackbar.textColor,
      },
    },
    button: {
      color: snackbar.textColor,
    },
  });

  const classes = useStyles();

  const handleClose = () => {
    //reset messages once snackbar closes
    if (props.error.status === true) {
      props.resetError();
    } else if (props.success.status === true) {
      props.resetSuccess();
    } else if (props.warning.status === true) {
      props.resetWarning();
    }
    // props.resetHealth();
  };

  function handleFormat() {
    // Alert message settings
    if (props.error.status === true) {
      setValues({
        bckgrndColor: colors.error,
        message: props.error.message,
        icon: <ErrorIcon />,
        textColor: colors.snackbarText,
      });
      // Success message settings
    } else if (props.success.status === true) {
      setValues({
        bckgrndColor: colors[props.theme].primary,
        message: props.success.message,
        icon: <CheckIcon />,
        textColor: colors.snackbarText,
      });
    } else if (props.warning.status === true) {
      setValues({
        bckgrndColor: colors.warning,
        message: props.warning.message,
        icon: <WarningIcon />,
        textColor: colors.snackbarText,
      });
    }
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      onClose={handleClose}
      open={props.error.status || props.success.status || props.warning.status}
      disableWindowBlurListener={true}
      onEnter={() => handleFormat()} // On entering set the snackbar format and message
      TransitionComponent={Slide}
      autoHideDuration={5000} // 5 second duration
      className={classes.root}
      message={
        <div className={classes.messageContainer}>
          {snackbar.icon}
          <Typography className={classes.message}>
            {snackbar.message}
          </Typography>
        </div>
      }
      action={[
        <IconButton
          key="close"
          onClick={handleClose}
          className={classes.button}
        >
          <CloseIcon />
        </IconButton>,
      ]}
    />
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { resetError, resetSuccess, resetWarning },
    dispatch
  );
};

const mapStateToProps = (state) => {
  return {
    error: state.utility.error,
    success: state.utility.success,
    warning: state.utility.warning,
    theme: state.utility.theme,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SnackbarInfo);
